import { useAuthContext } from '../context/AuthContext';

/** Convenience re-export so components can `import useAuth from '../hooks/useAuth'`. */
export default function useAuth() {
  return useAuthContext();
}

export const ROLES = {
  ADMIN: 'ADMIN',
  APPROVER: 'APPROVER',
  TECHNICIAN: 'TECHNICIAN',
  CLIENT: 'CLIENT',
};
